module.exports = __webpack_public_path__ + "img/aftersale.cdbbd452.png";